module.exports = __webpack_public_path__ + "img/skyline-landmarks.1de7ad0.png";